<template lang="pug">
  m-table(
    store-name="adminparticipants"
    :query-filter="queryFilter"
    :headers="headers"
  )
</template>

<script>
import { mapGetters } from 'vuex'
import TKeyValueData from '~/components/templates/t-key-value-data'
import {
  participantRolesUkMap,
  participantStatusesUkMap
} from '~/modules/documents/constants/participants'
import MTable from '~/components/modules/tables/m-table'

export default {
  name: 'BlockDocumentParticipants',
  components: { MTable, TKeyValueData },
  props: {
    documentId: {
      type: String,
      default: null
    }
  },
  computed: {
    ...mapGetters('adminparticipants', {
      participants: 'items'
    }),
    headers() {
      return [
        {
          text: 'User',
          valueFormatter: participant =>
            this._.get(participant, 'user.name') || this._.get(participant, 'user.email'),
          sortable: false,
          filterable: false
        },
        {
          text: 'Organization',
          component: 'e-html-insert',
          valueFormatter: participant =>
            participant.organization
              ? this._.get(participant, 'organization.name') +
                '<br>' +
                `<small>${this._.get(participant, 'organization.edrpou')}</small>`
              : null,
          sortable: false,
          filterable: false
        },
        {
          text: 'Role',
          value: 'role',
          valueFormatter: participant => participantRolesUkMap[participant.role],
          sortable: false,
          filterable: false
        },
        {
          text: 'Status',
          value: 'status',
          valueFormatter: participant => participantStatusesUkMap[participant.status],
          sortable: false,
          filterable: false
        },
        {
          text: 'Signature required',
          valueFormatter: participant =>
            participant.isSignatureRequired ? this.$t('Yes') : this.$t('No'),
          sortable: false,
          filterable: false
        }
      ]
    },
    queryFilter() {
      return {
        'document.id': this.documentId
      }
    }
  }
}
</script>

<style scoped lang="scss"></style>
